import { render } from "./footer.html?vue&type=template&id=0cf829f8&scoped=true&ts=true"
import script from "./footer.ts?vue&type=script&lang=ts"
export * from "./footer.ts?vue&type=script&lang=ts"

import "./footer.scss?vue&type=style&index=0&id=0cf829f8&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf829f8"]])

export default __exports__